<div class="user-wrapper">

  <div class="avatar-wrapper">
    <yu-avatar [picture]="user.picture || 'assets/img/empty-img/no_user.png'"></yu-avatar>
  </div>

  <div class="title">{{ user.nombre }}</div>

</div>
